module.exports = __webpack_public_path__ + "assets/img/wait_pay.31c33648.png";